<!--
  @deprecated Prefer the PrimeVue `v-tooltip` directive (registered globally in main.js)
  for new code and when editing call sites. This wrapper exists for legacy markup only.
  self-start: flex parents default to align-items:stretch; without this, the wrapper
  grows to the row height and contents look stretched.
-->
<template>
  <div
    v-if="shouldShow && placement === 'bottom'"
    v-tooltip.bottom="tooltipOptions"
    class="self-start"
    v-bind="attrs"
  >
    <slot />
  </div>
  <div
    v-else-if="shouldShow && placement === 'top'"
    v-tooltip.top="tooltipOptions"
    class="self-start"
    v-bind="attrs"
  >
    <slot />
  </div>
  <div v-else class="self-start" v-bind="attrs">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue';

const props = withDefaults(
  defineProps<{
    text?: string | string[];
    placement?: 'top' | 'bottom';
    disabled?: boolean;
  }>(),
  {
    text: '',
    placement: 'bottom',
    disabled: false,
  },
);

const attrs = useAttrs();

const displayValue = computed(() => {
  const t = props.text;
  if (t == null || t === '') {
    return '';
  }
  if (Array.isArray(t)) {
    return t.filter(Boolean).join('\n');
  }
  return String(t);
});

const shouldShow = computed(
  () => !props.disabled && displayValue.value.length > 0,
);

const tooltipOptions = computed(() => ({
  value: displayValue.value,
  showDelay: 1000,
  hideDelay: 100,
}));
</script>
